import Reports from "../pages/Reports";
import SalesRepLayout from "../layout/SalesRepLayout";
import Customer from "../pages/Customer";
import Dashboard from "../pages/Dashboard";
import Product from "../pages/Product";
import Schedule from "../pages/Schedule";
import SingleReports from "../../admin/pages/SingleReports";
import Profile from "../pages/Profile";
import { ComponentType, Suspense } from "react";
import LoadingPage from "../../components/Loading/LoadingPage";
import { Navigate } from "react-router-dom";

interface LazyComponentProps {
  component: ComponentType;
}

// Wrap component with Suspense
const LazyComponent = ({ component: Component }: LazyComponentProps) => (
  <Suspense fallback={<LoadingPage />}>
    <Component />
  </Suspense>
);

const SalesRepRoutes = [
  {
    path: "/salesRep/:name",
    element: <SalesRepLayout />,
    errorElement: <Navigate to="/" replace />,
    children: [
      {
        index: true,
        element: <LazyComponent component={Dashboard} />,
      },
      {
        path: "dashboard",
        element: <LazyComponent component={Dashboard} />,
      },
      {
        path: "customers",
        element: <LazyComponent component={Customer} />,
      },
      {
        path: "product",
        element: <LazyComponent component={Product} />,
      },
      {
        path: "schedule",
        element: <LazyComponent component={Schedule} />,
      },
      {
        path: "reports",
        element: <LazyComponent component={Reports} />,
      },
      {
        path: "profile",
        element: <LazyComponent component={Profile} />,
      },
    ],
  },
];
export default SalesRepRoutes;
